import { createFileRoute, Link } from "@tanstack/react-router";
import { Cop31NewsFeed } from "@/components/Cop31NewsFeed";
import { hreflangLinks } from "@/lib/seo";
import { pageTitle } from "@/lib/brand";

const SITE_URL = "https://smartsustainability.ai";

export const Route = createFileRoute("/cop31-news-archive")({
  component: Cop31NewsArchiveEn,
  head: () => ({
    meta: [
      { title: pageTitle("COP31 News Archive", "en") },
      {
        name: "description",
        content:
          "Automatically updated archive of COP31 Antalya 2026 coverage from national and accredited English-language outlets.",
      },
      { property: "og:title", content: "COP31 News Archive" },
      {
        property: "og:description",
        content: "COP31 coverage from accredited outlets, refreshed every morning.",
      },
      { property: "og:type", content: "article" },
      { property: "og:url", content: `${SITE_URL}/cop31-news-archive` },
      { property: "og:locale", content: "en_US" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: `${SITE_URL}/cop31-news-archive` },
      ...hreflangLinks("/cop31-haber-arsivi", "/cop31-news-archive"),
    ],
  }),
});

function Cop31NewsArchiveEn() {
  return (
    <article className="max-w-3xl mx-auto px-6 py-20">
      <span className="text-clay text-xs uppercase tracking-[0.25em] font-medium">
        News Archive
      </span>
      <h1 className="font-serif text-4xl md:text-5xl mt-4 mb-4 leading-tight">
        COP31 News Archive
      </h1>
      <p className="mb-8 text-sm leading-relaxed text-muted-foreground">
        Only national and accredited outlets (Reuters, The Guardian, Bloomberg, AP,
        Anadolu Agency and peers) are included. The list refreshes automatically every
        morning at 08:00.
      </p>

      <Cop31NewsFeed lang="en" limit={200} offset={5} showArchiveLink={false} />

      <Link
        to="/cop31-guide"
        className="mt-10 inline-block text-xs font-semibold uppercase tracking-[0.2em] text-clay underline underline-offset-4 hover:no-underline"
      >
        ← COP31 Guide
      </Link>
    </article>
  );
}
